"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledForm = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const react_1 = __importDefault(require("react"));
const PREFIX = "Form";
exports.classes = {
    rightAlignButton: `${PREFIX}-rightAlignButton`,
    button: `${PREFIX}-button`,
    buttonContainer: `${PREFIX}-buttonContainer`,
    buttonWrapper: `${PREFIX}-buttonWrapper`
};
exports.StyledForm = react_1.default.memo((0, styles_1.styled)("form")(() => ({
    [`&.${exports.classes.rightAlignButton}`]: {
        [`.${exports.classes.buttonWrapper}`]: {
            justifyContent: "flex-end"
        },
        [`.${exports.classes.button}`]: {
            marginRight: 0,
            marginLeft: "15px"
        }
    },
    [`.${exports.classes.button}`]: { marginTop: "15px", marginRight: "15px" },
    [`.${exports.classes.buttonWrapper}`]: {
        display: "flex"
    },
    [`.${exports.classes.buttonContainer}`]: {
        width: "max-content",
        marginTop: "15px",
        [`.${exports.classes.button}`]: {
            margin: 0
        }
    }
})));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Zvcm0vc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGlEQUE4QztBQUM5QyxrREFBMEI7QUFFMUIsTUFBTSxNQUFNLEdBQUcsTUFBTSxDQUFDO0FBRVQsUUFBQSxPQUFPLEdBQUc7SUFDckIsZ0JBQWdCLEVBQUUsR0FBRyxNQUFNLG1CQUFtQjtJQUM5QyxNQUFNLEVBQUUsR0FBRyxNQUFNLFNBQVM7SUFDMUIsZUFBZSxFQUFFLEdBQUcsTUFBTSxrQkFBa0I7SUFDNUMsYUFBYSxFQUFFLEdBQUcsTUFBTSxnQkFBZ0I7Q0FDekMsQ0FBQztBQUVXLFFBQUEsVUFBVSxHQUFHLGVBQUssQ0FBQyxJQUFJLENBQ2xDLElBQUEsZUFBTSxFQUFDLE1BQU0sQ0FBQyxDQUFDLEdBQUcsRUFBRSxDQUFDLENBQUM7SUFDcEIsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxnQkFBZ0IsRUFBRSxDQUFDLEVBQUU7UUFDakMsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxhQUFhLEVBQUUsQ0FBQyxFQUFFO1lBQzdCLGNBQWMsRUFBRSxVQUFVO1NBQzNCO1FBQ0QsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFO1lBQ3RCLFdBQVcsRUFBRSxDQUFDO1lBQ2QsVUFBVSxFQUFFLE1BQU07U0FDbkI7S0FDRjtJQUNELENBQUMsSUFBSSxlQUFPLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFLFNBQVMsRUFBRSxNQUFNLEVBQUUsV0FBVyxFQUFFLE1BQU0sRUFBRTtJQUNsRSxDQUFDLElBQUksZUFBTyxDQUFDLGFBQWEsRUFBRSxDQUFDLEVBQUU7UUFDN0IsT0FBTyxFQUFFLE1BQU07S0FDaEI7SUFDRCxDQUFDLElBQUksZUFBTyxDQUFDLGVBQWUsRUFBRSxDQUFDLEVBQUU7UUFDL0IsS0FBSyxFQUFFLGFBQWE7UUFDcEIsU0FBUyxFQUFFLE1BQU07UUFDakIsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFO1lBQ3RCLE1BQU0sRUFBRSxDQUFDO1NBQ1Y7S0FDRjtDQUNGLENBQUMsQ0FBQyxDQUNKLENBQUMifQ==